var months = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

export function dateDBtoBR(date_string: string){
  try {
    let aux = date_string.split(" ");
    let date = "";
    if(aux.length===2){
      date = date[0]; 
    } else {
      date = date_string.split("T")[0];
    }

    const [ Y, M, D ] = date.split("-");
    return `${D}/${M}/${Y}`;
  } catch (error) {
    return null;
  }
}

export const getListYear = (currentDate: any)=>{
  try {
    let aux = new Date(currentDate.year,currentDate.month,currentDate.day)
    aux.setMonth(aux.getMonth()+6)
    let first = 2022;
    let last = aux.getFullYear()
    let list = [];
    for (let i = last; i >= first; i--) {
      list.push({value:i,name:i.toString()})
    }
    return list;
  } catch (error) {
    return [{value:20223,name:"2023"}]
  }
}

export const getListYearWithValue = (currentDate: any, value: any) => {
  let aux = new Date(currentDate.year,currentDate.month,currentDate.day)
  aux.setMonth(aux.getMonth()+6)
  let first = 2022;
  let last = aux.getFullYear()
  let list = [];
  for (let i = last; i >= first; i--) {
    list.push({value:i,name:i.toString()})
  }
  if(!!value && !list.filter(a=>a.name === value).length){
    return [
      {name:value, value:value},
      ...list
    ]
  }
  return list;
}

export const listYears = (()=>{
  let aux = new Date();
  let first = 2021;
  let last = aux.getFullYear()
  let list = [];
  for (let i = last; i >= first; i--) {
    list.push({value:i,name:i.toString()})
  }
  return list;
})();

export function getListMonth(date_string:string, length: number):{label:string,value:string}[]{
  let d = new Date(date_string);
  let r:{label:string,value:string}[]= [];
  for (let index = 0; index < length; index++) {
    d.setMonth(d.getMonth()+1);
    r.push({
      label:`${months[d.getMonth()]}/${d.getFullYear()}`,
      value:`${d.getFullYear()}-${d.getMonth()+1}-${d.getDay()}`
    })
  }
  return r;
}